export default "__VITE_ASSET__$iXYGrn0__"